"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormV2 = exports.FormV2DefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var utils_1 = require("@shapeable/utils");
var field_container_1 = require("../../components/elements/field-container");
var use_form_field_components_1 = require("../hooks/use-form-field-components");
var lodash_1 = require("lodash");
var use_form_1 = require("../hooks/use-form");
var value_is_empty_1 = require("../utils/value-is-empty");
var cls = (0, utils_1.classNames)('form-v2');
exports.FormV2DefaultProps = {
  fields: []
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var FieldsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var FormStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-top: 0;\n    padding-top: 0;\n  "], ["\n    margin-top: 0;\n    padding-top: 0;\n  "])))
});
var FieldStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Form: styled_components_1.default.form(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), FormStyles),
  Fields: styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), FieldsStyles),
  FieldContainer: (0, styled_components_1.default)(field_container_1.FieldContainer)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), FieldStyles)
};
var FormV2 = function (props) {
  var className = props.className,
    fields = props.fields,
    name = props.name;
  var formFieldComponents = (0, use_form_field_components_1.useFormFieldComponents)();
  // form state
  var form = (0, use_form_1.useForm)(name);
  var handleSubmit = function (event) {
    event.preventDefault();
    event.stopPropagation();
    if (props.onSubmit) {
      props.onSubmit({
        event: event,
        fields: form.fields
      });
    }
  };
  var handleKeyDown = function (event) {
    if (event.key === 'Escape' && props.onEscape) {
      props.onEscape();
    }
  };
  // setup a validator effect
  react_1.default.useEffect(function () {
    var isValid = fields.every(function (field) {
      var _a;
      // if the field is not required, it's valid
      if (!field.required) {
        return true;
      }
      // if the field is required, it must have a value
      return !(0, value_is_empty_1.valueIsEmpty)((_a = form.fields[field.name]) === null || _a === void 0 ? void 0 : _a.value);
    });
    form.patch({
      isValid: isValid
    });
  }, [form.fields]);
  return react_1.default.createElement(My.Container, {
    className: cls.name(className)
  }, react_1.default.createElement(My.Form, {
    method: "post",
    /* @ts-ignore */
    onKeyDown: handleKeyDown,
    onSubmit: handleSubmit
  }, fields.map(function (field) {
    var _a;
    var Component = formFieldComponents[field.type];
    // setup a default change handler
    var handleChange = function (result) {
      var _a;
      form.patchFields((_a = {}, _a[field.name] = result, _a));
      // if there was a specific handler, call it too.
      if (field.onChange) {
        field.onChange(result);
      }
    };
    var isHidden = (0, lodash_1.includes)(['hidden', 'nameHidden', 'id'], field.type);
    // limit the fields passed in as the new form spec is not type-compatible (old spec needs to be deprecated)
    var fieldContainerFieldProp = (0, lodash_1.pick)(field, ['name', 'label', 'description', 'required']);
    var component = react_1.default.createElement(Component
    // note that the spread here will pass extra fields through from EntityFormField too. 
    , __assign({}, field, {
      value: (_a = form.fields[field.name]) === null || _a === void 0 ? void 0 : _a.value,
      onChange: handleChange
    }));
    return isHidden ? component : react_1.default.createElement(My.FieldContainer, {
      key: field.name,
      field: fieldContainerFieldProp
    }, component);
  })));
};
exports.FormV2 = FormV2;
exports.FormV2.cls = cls;
exports.FormV2.defaultProps = exports.FormV2DefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;